/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {path: "*", name: '404', view: '404'},
    {
        path: '/forgot-password',
        name: 'forgot-password',
        view: 'Auth/ForgotPasswordView'
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        view: 'Auth/ResetPasswordView'
    },
    {
        path: '/2fa-verification',
        name: '2fa-verification',
        view: 'Auth/TwoFactorVerificationView'
    },
    {
        path: '/',
        name: 'Dashboard',
        view: 'Dashboard'
    },
    {
        path: '/admin/users',
        name: 'user-search',
        view: 'User/UserSearch'
    },
    {
        path: '/admin/user-authentication-events',
        name: 'user-authentication-events',
        view: 'Admin/UserAuthenticationEventsView'
    },
    {
        path: '/admin/user-authentication-tokens',
        name: 'user-authentication-tokens',
        view: 'Admin/UserAuthenticationTokensView'
    },
    {
        path: '/time-tracking/schedule',
        name: 'time-tracking-schedule',
        view: 'TimeTracking/TimeTrackingSearchView'
    },
    {
        path: '/time-tracking/conditions',
        name: 'time-tracking-conditions',
        view: 'TimeTracking/TimeTrackingConditionsSearchView'
    },
    {
        path: '/time-tracking/sessions',
        name: 'time-tracking-sessions',
        view: 'TimeTracking/TimeTrackingSessionsSearchView'
    },
    {
        path: '/time-tracking/calendar',
        name: 'time-tracking-calendar',
        view: 'TimeTracking/WorkCalendarView'
    },
    {
        path: '/admin/webhooks',
        name: 'webhook-search',
        view: 'Webhook/WebhookSearchView'
    },
    {
        path: '/admin/order-attachment-types',
        name: 'order-attachment-types',
        view: 'OrderAttachmentTypes/OrderAttachmentTypesView'
    },
    /*
     * The warehouse's own pages, as opposed to the article-pinned widgets in the product editor.
     * A product manager reads an article's stock from there and is deliberately not let in here,
     * so these carry the role the nav menu already hides them by — the menu only stops the entry
     * being offered, while this stops the URL being opened.
     */
    {
        path: '/warehouses',
        name: 'warehouse-search',
        view: 'Warehouse/WarehouseSearchView',
        requires_role: 'warehouse_manager'
    },
    {
        path: '/warehouses/movements',
        name: 'warehouse-stock-movements',
        view: 'Warehouse/WarehouseStockMovementView',
        requires_role: 'warehouse_manager'
    },
    {
        path: '/warehouses/reservations',
        name: 'warehouse-stock-reservations',
        view: 'Warehouse/WarehouseStockReservationView',
        requires_role: 'warehouse_manager'
    },
    {
        path: '/warehouses/stock',
        name: 'warehouse-product-stock',
        view: 'Warehouse/WarehouseProductStockView',
        requires_role: 'warehouse_manager'
    },
    {
        path: '/warehouses/locations/:location_id(\\d+)/stock',
        name: 'warehouse-location-stock',
        view: 'Warehouse/WarehouseLocationStockView',
        requires_role: 'warehouse_manager'
    },
    {
        path: '/warehouses/:warehouse_id(\\d+)/locations',
        name: 'warehouse-locations',
        view: 'Warehouse/WarehouseLocationsView',
        requires_role: 'warehouse_manager'
    },
    {
        path: '/admin/users/:id(\\d+)/:section?/:widget?',
        name: 'user-editor',
        view: 'User/User'
    },
    {
        path: '/admin/pling-settings/:section?/:widget?',
        name: 'pling-settings',
        view: 'Admin/PlingSettings'
    },
    {
        path: '/profile/:section?/:widget?',
        name: 'Profile',
        view: 'User/Profile'
    },
    {
        path: '/profile/sessions',
        name: 'profile-sessions',
        view: 'User/Sessions'
    },
    {
        path: '/settings',
        name: 'Settings',
        view: 'Settings'
    },
    {
        path: '/coupons',
        name: 'coupon-search',
        view: 'Coupon/CouponSearchView',
    },
    {
        path: '/coupons/:id(\\d+)/:section?/:widget?',
        name: 'coupon-editor',
        view: 'Coupon/CouponEditorView',
    },
    {
        path: '/coupon-conditions',
        name: 'coupon-condition-search',
        view: 'Coupon/CouponConditionSearchView',
    },
    {
        path: '/coupon-conditions/:id(\\d+)/:section?/:widget?',
        name: 'coupon-condition-editor',
        view: 'Coupon/CouponConditionEditorView',
    },
    {
        path: '/coupon-locks',
        name: 'coupon-lock-search',
        view: 'Coupon/CouponLockSearchView',
    },
    {
        path: '/coupon-redemptions',
        name: 'coupon-redemption-search',
        view: 'Coupon/CouponRedemptionSearchView',
    },
    {
        path: '/orders/orders',
        name: 'order-search',
        view: 'Orders/OrderSearchView'
    },

    {
        path: '/orders/parcels',
        name: 'ParcelSearch',
        view: 'Orders/ParcelSearch'
    },

    {
        path: '/orders/:id(\\d+)/:section?/:widget?',
        name: 'order-manager',
        view: 'Orders/Editor'
    },
    {
        path: '/invoices',
        name: 'Invoices',
        view: 'Invoices/InvoiceSearchView'
    },
    {
        path: '/invoices/:id(\\d+)',
        name: 'invoice-manager',
        view: 'Invoices/Editor'
    },
    {
        path: '/payments',
        name: 'Payments',
        view: 'Payments/PaymentSearchView'
    },
    {
        path: '/refunds',
        name: 'refund-search',
        view: 'Payments/RefundSearchView'
    },
    {
        path: '/products/edit/:id(\\d+)/:section?/:widget?',
        name: 'product-editor',
        view: 'Products/Editor'
    },

    {
        path: '/products/looks',
        name: 'look-search',
        view: 'Products/LookSearchView'
    },

    {
        path: '/products/looks/:id(\\d+)',
        name: 'look',
        view: 'Products/LookView'
    },

    {
        path: '/products/feeds',
        name: 'product-feeds',
        view: 'Products/ProductFeedView'
    },
    {
        path: '/products/discount-presets',
        name: 'product-discount-presets',
        view: 'Products/ProductDiscountPresetView'
    },
    {
        path: '/products/manufacturers',
        name: 'product-manufacturer-manager',
        view: 'Products/ManufacturerManagerView'
    },
    {
        path: '/products/brands',
        name: 'product-brand-manager',
        view: 'Products/BrandManagerView'
    },
    {
        path: '/faq',
        name: 'faq-search',
        view: 'FAQ/FAQSearchView'
    },
    {
        path: '/faq/:id(\\d+)',
        name: 'faq',
        view: 'FAQ/FAQView'
    },
    {
        path: '/faq/groups',
        name: 'faq-group-search',
        view: 'FAQ/FAQGroupSearchView'
    },
    {
        path: '/faq/groups/:id(\\d+)',
        name: 'faq-group',
        view: 'FAQ/FAQGroupView'
    },
    {
        path: '/products/quality',
        name: 'product-quality-search',
        view: 'Products/ProductQualitySearchView'
    },
    {
        path: '/products/:view?/:tax?/:term?',
        name: 'product-search',
        view: 'Products/ProductSearchView'
    },
    {
        path: '/product-tags',
        name: 'Product Tags',
        view: 'Products/ProductTagSearchView'
    },
    {
        path: '/product-categories',
        name: 'Product Categories',
        view: 'Products/Categories'
    },

    {
        path: '/product-attributes/:section?/:widget?',
        name: 'attribute-manager',
        view: 'Products/AttributeManagerView'
    },

    {
        path: '/product-attribute-sets',
        name: 'Product Attributes Sets',
        view: 'Products/AttributesSetSearchView'
    },

    {
        path: '/product-attribute-sets/:id',
        name: 'Product Attribute Set Editor',
        view: 'Products/AttributesSetEditorView'
    },

    {
        path: '/product-content-recipes',
        name: 'Product Content Recipes',
        view: 'Products/ContentRecipeSearchView'
    },

    {
        path: '/product-content-recipes/:id',
        name: 'Product Content Recipe Editor',
        view: 'Products/ContentRecipeEditorView'
    },

    {
        path: '/product-media',
        name: 'Product Media',
        view: 'Media/MediaSearch'
    },
    {
        path: '/customers',
        name: 'customer-search',
        view: 'Customers/CustomerSearch'
    },
    {
        path: '/customers/:id(\\d+)/:section?/:widget?',
        name: 'customer-manager',
        view: 'Customers/Editor'
    },
    {
        path: '/shops',
        name: 'shop-search',
        view: 'Shop/Shops'
    },
    {
        path: '/shop-groups',
        name: 'shop-group-manager',
        view: 'Shop/ShopGroupManagerView'
    },
    {
        path: '/shipping-settings/:section?/:widget?',
        name: 'ShippingMethods',
        view: 'Shop/ShippingMethodView'
    },
    {
        path: '/payment-settings/:section?/:widget?',
        name: 'PaymentMethods',
        view: 'Shop/PaymentMethodView'
    },
    {
        path: '/shops/:id(\\d+)/:section?/:widget?',
        name: 'shop-manager',
        view: 'Shop/ShopEditor'
    },
    {
        path: '/price-lists',
        name: 'price-lists',
        view: 'Shop/PriceListsView'
    },
    {
        path: '/translations',
        name: 'translation-search',
        view: 'Translator/TranslationSearch'
    },

    {
        path: '/translations/:id(\\d+)',
        name: 'translation-editor',
        view: 'Translator/TranslationEditor'
    },
    {
        path: '/admin/api-log',
        name: 'APILog',
        view: 'Admin/ApiLog'
    },
    {
        path: '/admin/cron',
        name: 'CronJobs',
        view: 'Admin/CronJobs'
    },
    {
        path: '/admin/export',
        name: 'ExportJobs',
        view: 'Admin/ExportJobs'
    },
    {
        path: '/admin/tax-manager/:section?/:widget?',
        name: 'TaxManager',
        view: 'Admin/TaxManager'
    },
    {
        path: '/admin/sync-queue',
        name: 'SyncQueue',
        view: 'Admin/SyncQueue'
    },
    {
        path: '/admin/bank-accounts',
        name: 'bank-account-search',
        view: 'Admin/BankAccountSearch'
    },
    {
        path: '/admin/files',
        name: 'FileSearch',
        view: 'Admin/FileSearchView'
    },
    {
        path: '/admin/communication',
        name: 'Communication',
        view: 'Admin/Communication'
    },
    {
        path: '/admin/api-log/:id(\\d+)',
        name: 'ApiLogEntry',
        view: 'Admin/ApiLogEntry'
    },

    {
        path: '/test',
        name: 'Test',
        view: 'TestView'
    },
    {
        path: '/scanner-poc',
        name: 'scanner-poc',
        view: 'ScannerPOC'
    },
    {
        path: '/storage-scanner-poc',
        name: 'storage-scanner-poc',
        view: 'StorageScannerPOC'
    }
]
